export enum DateView {
	Year = "year",
	Month = "month",
	Day = "day",
}

export type DatePanelMode = DateView.Month | DateView.Day;
